module.exports = __webpack_public_path__ + "44cc908f7adf4c90d17f7849289116c5.svg";